var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcZoomMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107.152,
    height: 98.861,
    viewBox: "0 0 107.152 98.861",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "17.509%",
    x2: "100%",
    y2: "81.379%",
    id: "g4ausmlj8a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4.796c12.553 0 17.117 1.28 21.71 3.736 4.53 2.423 8.087 5.979 10.51 10.51.151.283.298.565.44.85l.21.427c2.031 4.226 3.085 9.038 3.085 20.433V62.11c0 11.395-1.054 16.207-3.085 20.432l-.21.428c-.142.285-.289.567-.44.85-2.423 4.531-5.98 8.087-10.51 10.51-5.029 2.571-9.738 3.736-21.71 3.736H36.751c-12.554 0-17.117-1.28-21.71-3.736-4.531-2.423-8.087-5.979-10.51-10.51a32.825 32.825 0 0 1-.749-1.483C1.778 77.894.831 73.106.797 62.693v-25.94c0-10.826.947-15.715 2.784-19.79.436-.935.687-1.428.95-1.92 2.424-4.532 5.98-8.088 10.511-10.511.491-.263.982-.513 1.483-.749C20.967 1.778 25.755.831 36.168.797z",
    stroke: "url(#g4ausmlj8a)",
    strokeWidth: 1.593
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 34.643v22.629c.02 5.117 4.201 9.234 9.3 9.214h33c.937 0 1.692-.755 1.692-1.672V42.187c-.02-5.117-4.2-9.236-9.3-9.215h-33c-.938 0-1.692.754-1.692 1.671zm46.093 8.828 13.624-9.949c1.183-.978 2.1-.734 2.1 1.04v30.333c0 2.02-1.12 1.774-2.1 1.04L68.76 56.007V43.471z",
    fill: "#4A8CFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZoomMeeting);
export default __webpack_public_path__ + "static/media/ic_zoom_meeting.14ab59a3aa47b97a6936519056b092ef.svg";
export { ForwardRef as ReactComponent };